// The HTML for the audio player is rendered at views/guide/show.html.erb
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { safelyParseJSON } from '../utilities';

export default function AudioSetup() {
    const navigate = useNavigate();
    const audioWrapper = document.querySelector('.audio-wrapper');

    const handleAudioClick = (e) => {
        // Only open on small screens and if it wasn't a tap on a button
        if (
            e.target.tagName !== 'BUTTON' &&
            !e.target.classList.contains('audio-player__progress') &&
            !e.target.classList.contains('audio-player__timeline')
        ) {
            // If on guide index page, navigate to the stop item and keep playing the audio
            // Get the previous location saved in the audio player DOM and navigate there
            const { guideId, params } = safelyParseJSON(audioWrapper.dataset.activeItem) || {};

            if (!guideId || !params) return;

            let activeItemParams = params;
            if (window.isNavSmall) activeItemParams.open = true;
            activeItemParams = new URLSearchParams(activeItemParams).toString();
            const activeItemUrl = `/${ guideId }?${ activeItemParams }`;

            // don't navigate if you're already on the stop
            if (window.location.pathname.includes(activeItemUrl)) return;

            navigate(activeItemUrl);
        }
    };

    // Handle clicks on the audio player
    useEffect(() => {
        audioWrapper?.addEventListener('click', handleAudioClick);

        return () => {
            audioWrapper?.removeEventListener('click', handleAudioClick);
        };
    }, []);

    return null;
}
